import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from "./ReportStyle";

/**
 * Page.js — RA Masale format
 * ------------------------------------------------------------------
 * Entry point, same role as your existing InvoiceA4PDFReport/Page.js:
 * builds the jsPDF doc, calls the header/body/footer drawing
 * functions in order, then opens the PDF.
 *
 * `companyDetails` = seller letterhead info NOT present in your
 * invoice API response (company name, address, FSSAI Lic No, PAN,
 * CIN, GSTIN). Pass it in from your company/theme settings — see the
 * TODO note in ReportStyle.js for where this should come from.
 * ------------------------------------------------------------------
 */

const pageHeder = (doc, data, companyDetails) => {
    style.pageBorder(doc);
    style.pageHeder(doc, data, companyDetails);
    let y = style.reportPartyAndInvoiceInfo(doc, data);
    y = style.reportIRNRow(doc, data, y);
    return y;
};
const FOOTER_MIN_Y = 745;
const reportBody = (doc, data, headerBottomY) => {
    const tableEndY = style.tableBody(doc, data, headerBottomY);
    const footerStartY = Math.max(tableEndY, FOOTER_MIN_Y);
    style.reportFooterTotals(doc, data, footerStartY);
};

const pageFooter = (doc) => {
    style.pageFooter(doc);
};

const InvioceReport_RAMasale = (data, companyDetails) => {
    const doc = new jsPDF("p", "pt", "a4");

    const headerBottomY = pageHeder(doc, data, companyDetails);
    reportBody(doc, data, headerBottomY);
    pageFooter(doc);

    doc.setProperties({
        title: `InvoiceReport/${data.InvoiceDate}-${data.CustomerName}`,
    });

    const pdfUrl = URL.createObjectURL(doc.output("blob"));
    window.open(pdfUrl);
};

export default InvioceReport_RAMasale;